export default {
  slug: "data-room-terms",
  title: "Investor data room terms",
  tier: "Group",
  group: "legal",
  appliesTo: "All persons requesting or holding investor data room access",
  lead: "Access to the data room is granted at our discretion to relevant persons, after we have verified your identity and eligibility. By requesting or accepting access you agree to these terms.",
  sections: [
    { id: "terms", h: "The terms", body: [
      { ul: [
        "Confidentiality. Everything in the data room is confidential. You may use it only to evaluate a possible investment in the vehicle concerned, and may share it only with your professional advisers who are bound by equivalent confidentiality, and only for that purpose.",
        "No offer. Data room content is information, not an offer. Any investment is made only under the offering documents of the relevant vehicle and after completion of subscription and know-your-customer procedures.",
        "Eligibility. You confirm that you are a relevant person as defined in our Investor access statement and that you will tell us at once if that ceases to be true.",
        "Accuracy. We take care that data room content is accurate at the date shown, but it is not audited unless stated, may be updated without notice, and is not a substitute for your own due diligence.",
        "Security. Your access credentials are personal. Do not share them. We log access to the data room and may withdraw it at any time without notice.",
        "Data protection. We process your personal data as described in our Privacy Policy.",
        "Law. These terms are governed by the law of England and Wales."
      ]}
    ]}
  ],
  version: "1.0",
  status: "Effective 22 September 2026",
  owner: "Director"
};
